import React from "react";
import ScrollableAnchor from "react-scrollable-anchor";

import Education from "./Education";
import Work from "./Work";
import Skills from "./Skills";

const Resume = () => (
    <section id="resume">
      {/* <Education />
      <Work /> */}
      <Skills />
    </section>
);

export default Resume;



// WEBPACK FOOTER //
// ./src/components/Resume.js